import { InertiaLink, usePage } from '@inertiajs/inertia-react'
import React from 'react'
import { Container } from '@/Components/Container'

export default function LandingLayout({ children }) {
  let { url, props } = usePage()

  return (
    <>
      {children}
      <Container size="max-w-2xl" className="self-center px-4 my-10 text-xs text-white sm:my-16">
        <div className="flex flex-col justify-between sm:flex-row">
          <div className="mb-2">En del av Gidås hållbarhetsbyrå AB och Dille Bolagen – Östersund</div>
          <div className="hidden sm:block">|</div>
          <div className="mb-2">Dille 226, 836 95 Ås</div>
          <div className="hidden sm:block">|</div>
          <div className="mb-2"><a href="mailto:hej@gidas.se">hej@gidas.se</a></div>
        </div>
      </Container>
    </>
  )
}
